(function($) {
	'use strict';
    
	$(window).ready(function() {
        var $slider = $(".similar-products__slider");
        
		$slider.on("init", function(event, slick) {
			$(slick.$slider).parent().removeClass("hidden");
		});

		$slider.slick({
			slidesToShow: 5,
			slidesToScroll: 5,
			prevArrow: $(".similar-product-slider-arrow-nav.prev"),
			nextArrow: $(".similar-product-slider-arrow-nav.next"),
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
		});
        
    });
	
})(jQuery);
